import { Search } from "lucide-react";

import type { MeUser } from "@/api/db/users";
import { CLINIC_BRAND } from "@/lib/brand";

import { PulsoMark } from "./pulso-mark";

export function AppTopbar({ user, onSearch }: { user: MeUser; onSearch: () => void }) {
	return (
		<header className="app-topbar">
			<div className="flex min-w-0 items-center gap-2">
				<PulsoMark className="size-6 shrink-0 text-primary md:hidden" />
				<span className="hidden text-xs font-semibold uppercase tracking-eyebrow text-primary sm:block">
					{CLINIC_BRAND}
				</span>
				<span className="font-display text-xl text-primary sm:hidden">Pulso</span>
			</div>
			<button
				type="button"
				onClick={onSearch}
				className="ml-auto flex min-h-11 items-center gap-2 rounded-md px-3 text-sm text-muted-foreground transition-colors hover:bg-secondary focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring md:mr-4 md:min-h-9 md:w-72 md:border md:border-border md:bg-background"
			>
				<Search className="size-4 shrink-0" />
				<span>Buscar pessoas</span>
				<kbd className="ml-auto hidden rounded-sm border border-border bg-card px-1.5 py-0.5 font-sans text-xs md:block">
					Ctrl K
				</kbd>
			</button>
			<span className="hidden max-w-48 truncate border-l border-border pl-4 text-sm font-medium text-foreground md:block">
				{user.name}
			</span>
		</header>
	);
}
